/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormHelpersService, ModalService } from 'app/shared/services';

@Component({
  selector: '[userArticleModalGeneral]',
  templateUrl: './user-article-modal.component.html',
  styleUrls: ['./user-article-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserArticleModalComponent implements OnInit {
  @Input() article;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  isEditMode = false;
  loading = true;
  userArticleForm: FormGroup;
  summaryErrorMessage = null;

  constructor(private modalService: ModalService, public fhs: FormHelpersService) {
    this.userArticleForm = new FormGroup({
      link: new FormControl('', Validators.required),
      title: new FormControl('', Validators.required),
    });
  }

  ngOnInit() {
    if (this.article) {
      this.isEditMode = true;
      this.userArticleForm.controls.link.setValue(this.article.url ? `${this.article.url}` : '');
      this.userArticleForm.controls.title.setValue(this.article.title ? `${this.article.title}` : '');
    }
  }

  close() {
    this.modalService.hideModal();
    this.closeModal.emit(null);
  }

  onSubmit($event) {
    $event.preventDefault();
    if (this.userArticleForm.invalid) {
      this.fhs.markFieldsAsDirty(this.userArticleForm);
      this.summaryErrorMessage = 'Please fill all mandatory fields';
      return;
    }
    this.summaryErrorMessage = null;
    let newArticle;
    if (this.article) {
      newArticle = {
        ...this.article,
        url: this.userArticleForm.value.link,
        title: this.userArticleForm.value.title,
      };
    } else {
      newArticle = {
        url: this.userArticleForm.value.link,
        title: this.userArticleForm.value.title,
      };
    }

    this.closeModal.emit(newArticle);
    this.modalService.hideModal();
  }
}
